import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

import {
  CommonConfigService,
  ControllerConnectionService
} from '@c4/core';
import { AuthorizationService } from '@c4/auth';

@Component({
  selector: 'sys-app',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private ready: Observable<boolean>;
  private authorized: Observable<boolean>;
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private store: Store<any>,
    private commonConfigService: CommonConfigService,
    private controllerService: ControllerConnectionService,
    private authorizationService: AuthorizationService
  ) {
    this.ready = this.store.select(state => state.authorization.initialized);
    this.authorized = this.store.select(state => state.authorization.authorized);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/app.component.ts